export default __webpack_public_path__ + "static/logo-15-fda9be7a474c3f549ec87ebcb52fef49.jpeg";